var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7859 22.6468L20.2618 19.1444V5.67028L18.5975 2.6093C18.4747 2.37593 18.2905 2.18053 18.0648 2.04422C17.839 1.90791 17.5803 1.83586 17.3166 1.83586C17.0529 1.83586 16.7942 1.90791 16.5685 2.04422C16.3428 2.18053 16.1586 2.37593 16.0358 2.6093L14.4727 5.67752V13.3842L1.23743 0.214063C1.13621 0.112009 1.0069 0.0424094 0.865974 0.0141372C0.725047 -0.0141351 0.578894 0.000201254 0.446147 0.0553183C0.313401 0.110435 0.200075 0.203836 0.120619 0.323612C0.041163 0.443388 -0.000823627 0.584113 1.22417e-05 0.727845V6.57483H1.5703V7.73264H1.22417e-05V12.3639H1.5703V13.5217H1.22417e-05V18.3339H1.5703V19.4917H1.22417e-05V23.1606C1.22417e-05 23.3525 0.0762523 23.5365 0.21196 23.6723C0.347668 23.808 0.531728 23.8842 0.723649 23.8842H23.2722C23.4159 23.885 23.5566 23.8431 23.6764 23.7636C23.7962 23.6841 23.8896 23.5708 23.9447 23.4381C23.9998 23.3053 24.0141 23.1592 23.9859 23.0182C23.9576 22.8773 23.888 22.748 23.7859 22.6468ZM5.7891 18.153V11.5969L12.3525 18.153H5.7891ZM18.8146 19.6799H15.92V17.9214H18.8146V19.6799ZM18.8146 16.7853H15.92V6.0321L17.3239 3.30399L18.8146 6.03933V16.7853Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasure);
export default __webpack_public_path__ + "static/media/measure.083aa53806bf5e288420bcd52a78571f.svg";
export { ForwardRef as ReactComponent };